<template>
    <div>
        <form @submit.prevent="onSubmit" id="change_pass_form">
            <vue-recaptcha
                v-if="captchaDriver === 'recaptcha'"
                ref="resetPassword"
                @verify="onVerify"
                @expired="onExpired"
                size="invisible"
                :sitekey="sitekey"
                :loadRecaptchaScript="true"
            >
            </vue-recaptcha>
            <arcaptcha-vue
                v-if="captchaDriver === 'arcaptcha'"
                ref="arcaptchaResetPassword"
                :site_key="arCaptchaKey"
                :invisible="true"
                :callback="onArcaptchaSuccess"
                :expired_callback="onArcaptchaExpired"
                :error_callback="onArcaptchaError"
            />
            <div class="login-form">
                <h1 class="m-0 mb-2 text-white-in-dark-mode text-right pr-5">
                    {{ $t('auth.title.recover_pass') }}
                </h1>
                <div class="form-field mt-3" style="direction: rtl">
                    <input
                        type="password"
                        :placeholder="$t('auth.placeholder.password')"
                        name="password"
                        id="password"
                        direction="ltr"
                        autocomplete="off"
                        v-model="password"
                    />
                </div>
                <div class="form-field mt-3" style="direction: rtl">
                    <input
                        type="password"
                        :placeholder="$t('auth.placeholder.password_confirm')"
                        name="password_confirm"
                        direction="ltr"
                        id="password_confirm"
                        v-model="password_confirm"
                    />
                </div>
                <div class="login-footer" style="margin-top: 15px">
                    <button
                        v-if="!loading"
                        type="submit"
                        id="change_pass_submit"
                    >
                        {{ $t('auth.btn.reset_pass') }}
                    </button>
                    <button
                        type="button"
                        v-else
                        disabled
                        id="change_pass_submit"
                    >
                        <span class="spinner-border"></span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { authService } from '@/common/api.service';
import $ from 'jquery';
import VueRecaptcha from 'vue-recaptcha';
import { reCaptchaKeys } from '@/constants/getRecaptchaKey';
import { arCaptchaKeys } from '@/constants/getArCaptchaKey';
import { getCaptchaDriver } from '@/constants/getCaptchaDriver';
import { KTApp } from '@/plugins/core/app';
import ArcaptchaVue from 'arcaptcha-vue';

export default {
    name: 'ResetPassword',
    props: ['phone', 'code'],
    components: {
        VueRecaptcha,
        ArcaptchaVue
    },
    data() {
        return {
            password: '',
            password_confirm: '',
            g_recaptcha_response: '',
            login_event: null,
            recaptcha_verified: false,
            sitekey: reCaptchaKeys,
            arCaptchaKey: arCaptchaKeys,
            captchaDriver: getCaptchaDriver,
            arcaptchaToken: '',
            arcaptchaVerified: false,
            loading: false
        };
    },
    methods: {
        onSubmit: function (e) {
            this.executeCaptcha();
            this.login_event = e;
        },
        async executeCaptcha() {
            this.loading = true;
            if (this.captchaDriver === 'recaptcha') {
                await this.$refs.resetPassword.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
                await this.$refs.arcaptchaResetPassword.execute();
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                this.changePass();
            }
        },
        onVerify(response) {
            this.recaptcha_verified = true;
            this.g_recaptcha_response = response;
            this.changePass(this.login_event);
        },
        onExpired() {
            this.recaptcha_verified = false;
            this.loading = false;
        },
        onArcaptchaSuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.changePass(this.login_event);
        },
        onArcaptchaExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.loading = false;
        },
        onArcaptchaError(error) {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.loading = false;
            this.showMsg(
                $('#change_pass_form'),
                'danger',
                'Captcha verification failed. Please try again.'
            );
        },
        resetCaptcha() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.resetPassword && this.$refs.resetPassword.reset();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptchaResetPassword &&
                    this.$refs.arcaptchaResetPassword.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
            }
        },
        isCaptchaVerified() {
            if (this.captchaDriver === 'recaptcha') {
                return this.recaptcha_verified;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaVerified && this.arcaptchaToken;
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                return true;
            }
            return false;
        },
        getCaptchaResponse() {
            if (this.captchaDriver === 'recaptcha') {
                return this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaToken;
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                return '';
            }
            return '';
        },
        changePass() {
            let btn = $('#change_pass_submit');
            let form = $('#change_pass_form');

            let params = {
                phone: this.phone,
                code: this.code,
                password: this.password,
                password_confirm: this.password_confirm
            };

            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            form.validate({
                ignore: '.ignore',
                rules: {
                    password: {
                        minlength: 5
                    },
                    password_confirm: {
                        minlength: 5,
                        equalTo: '#password'
                    }
                }
            });

            if (!form.valid()) {
                this.loading = false;
                return;
            }

            if (!this.isCaptchaVerified()) {
                this.loading = false;
                return;
            }

            KTApp.progress(btn);
            authService
                .changePass(params)
                .then((response) => {
                    this.showMsg(form, 'success', response.data.message);

                    this.$router.push('/login');
                })
                .catch((error) => {
                    this.showMsg(form, 'danger', error.response.data.message);
                    if (error.response.data.data) {
                        form.validate().showErrors(error.response.data.data);
                    } else {
                        this.showMsg(
                            form,
                            'danger',
                            error.response.data.message
                        );
                    }
                })
                .finally(() => {
                    KTApp.unprogress(btn);
                    this.loading = false;
                    this.resetCaptcha();
                });
        }
    }
};
</script>

<style scoped></style>